<template>
    <div>
        <Title :title="'作业批改'" :noBorder="true"></Title>
        <Menu mode="horizontal" :theme="'light'" active-name="exercisesPaper" class="tabs" @on-select="menuChange">
<!--            <MenuItem name="labReport">-->
<!--                实验报告-->
<!--            </MenuItem>-->
            <MenuItem name="exercisesPaper">
                习题试卷
            </MenuItem>
        </Menu>
        <div>
            <keep-alive>
                <component :is="currentPage"></component>
            </keep-alive>
        </div>
    </div>
</template>

<script>
    import Title from "../../../ability/components/title";
    // import labReport from "./labReport"
    import exercisesPaper from "./exercisesPaper"
    export default {
        name: "teachingScore",
        components: {
            Title,
            // labReport,
            exercisesPaper
        },
        data(){
            return {
                currentPage:'exercisesPaper'
            }
        },
        methods: {
            menuChange(name){
                this.currentPage = name
            }
        }
    }
</script>
<style lang="less">
    .tabs{
        height: 40px;
        line-height: 40px;
    }
</style>
<style scoped lang="less">
</style>
